import * as PIXI from "pixi.js";
import {Animatable} from "../core/Animatable";
import * as AssetHelpers from "../core/AssetHelpers";
import {texture} from "../core/AssetHelpers";
import {ContainerExtensions} from "../core/ContainerExtensions";
import {Mix} from "../core/Reflection";
import {Scalable} from "../core/Scalable";

export class PngSequence extends Mix(PIXI.extras.AnimatedSprite, Scalable, ContainerExtensions, Animatable) {

    constructor(pattern?: string) {
        super(pattern ? PngSequence.getTextures(pattern) : [PIXI.Texture.EMPTY]);
    }

    public static getTextures(pattern: string) {
        const textures = [];
        const e = /^([^{]*)\{(\d+)\}(.*)$/.exec(pattern)!;
        const n = parseInt(e[2], 10);
        const l = e[2].length;
        const p1 = e[1] || "";
        const p2 = e[3] || "";
        for (let i = n || 1; ; i++) {
            const j = i.toString(10);
            const t = texture(p1 + ("000" + j).slice(-Math.max(l, j.length)) + p2);
            if (t) {
                textures.push(t);
            } else {
                break;
            }
        }
        return textures;
    }

    public setTextures(pattern: string) {
        this.textures = PngSequence.getTextures(pattern);
    }

    public setLayoutTexture(t: string | PIXI.Texture, anchorX: number, anchorY: number) {
        this.textures = [(t instanceof PIXI.Texture ? t :
            t ? AssetHelpers.texture(t) : PIXI.Texture.EMPTY) || PIXI.Texture.EMPTY];
        this.anchor.x = anchorX;
        this.anchor.y = anchorY;
    }
}
